import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { ConnectionType } from '../../../../core/src/shared/enums';

export const ConnectionTypeSelect = ({
  value,
  onChange,
  rs485Supported,
}: {
  value: ConnectionType;
  onChange: (value: ConnectionType) => void;
  rs485Supported?: boolean;
}) => {
  return (
    <FormControl>
      <InputLabel id="connection-type-label">
        <FormattedMessage
          id="settings.service.connection_type"
          defaultMessage="Připojení"
        />
      </InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as ConnectionType)}
        labelId="connection-type-label"
        size="medium"
        label={
          <FormattedMessage
            id="settings.service.connection_type"
            defaultMessage="Připojení"
          />
        }
      >
        <MenuItem value={ConnectionType.ModbusTCP}>
          <FormattedMessage
            id="settings.service.modbus_tcp"
            defaultMessage="LAN/WiFi"
          />
        </MenuItem>
        <MenuItem value={ConnectionType.RS485} disabled={!rs485Supported}>
          <FormattedMessage
            id="settings.service.rs485"
            defaultMessage="RS485"
          />
        </MenuItem>
      </Select>
    </FormControl>
  );
};
